export default "/images/60bf3b5bdfc951a06cae3fcb5794445d.avif";